import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom'; // ✅ Added Navigate
import 'bootstrap/dist/css/bootstrap.min.css';

import HomePage from './pages/HomePage';
import DealerListPage from './pages/DealerListPage';
import DealerDetailsPage from './pages/DealerDetailsPage';

import Header from './components/Header';
import Footer from './components/Footer';
import DealerLayout from './components/DealerLayout';

import AdminDashboard from './admin/AdminDashboard';
import AddDealerPage from './admin/AddDealerPage';
import EditDealerPage from './admin/EditDealerPage';
import CategoryAdminPage from './admin/CategoryAdminPage';
import AdminLayout from './admin/AdminLayout';
import DealerAdminPage from './admin/DealerAdminPage';
import AdminReviewApproval from './admin/AdminReviewApprovalPage';
import FindDealerPage from './pages/FindDealerPage';
import LoginPage from './pages/LoginPage';
import SignUpPage from './pages/SignUpPage';
import ContactPage from './pages/ContactPage';
import RegisterDealerPage from './pages/RegisterDealerPage';
import AdminLeadsPage from "./admin/AdminLeadsPage";
import DealerLoginPage from './pages/DealerLoginPage';
import DealerDashboardPage from './pages/DealerDashboard';
import AdminLogin from './admin/AdminLogin';
import AdminEntry from './admin/AdminEntry';
import AdminRoute from './admin/AdminRoute';
import AdminReviewsPage from "./admin/AdminReviewPage";
import DealerLeadsPage from './pages/DealerLeadsPage';
import DealerReviewsPage from './pages/DealerReviewsPage';
import DealerProfilePage from './pages/DealerProfilePage';
import DealerInventoryPage from './pages/DealerInventoryPage';
import DealerApprovalPage from './pages/DealerApprovalPage';

export default function App() {
  return (
    <>
      <Header />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/dealers" element={<DealerListPage />} />
        <Route path="/dealer/:id" element={<DealerDetailsPage />} />
        <Route path="/find-dealer" element={<FindDealerPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/dealer/register" element={<RegisterDealerPage />} />
        <Route path="/dealer/login" element={<DealerLoginPage />} />
        <Route  path="/dealer/approval"  element={<DealerApprovalPage />}
/>
        
        <Route path="/dealer" element={<DealerLayout />}>
          <Route path="dashboard" element={<DealerDashboardPage />} />
          <Route path="inventory" element={<DealerInventoryPage />} />
          <Route path="reviews" element={<DealerReviewsPage />} />
          <Route path="leads" element={<DealerLeadsPage />} />
          <Route path="profile" element={<DealerProfilePage />} />
        </Route>

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminEntry />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminLayout />
              </AdminRoute>
            }
          >
          {/* Redirect /admin → /admin/dashboard */}
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="dealers" element={<DealerAdminPage />} />
          <Route path="add-dealer" element={<AddDealerPage />} />
          <Route path="edit-dealer/:id" element={<EditDealerPage />} />
          <Route path="categories" element={<CategoryAdminPage />} />
          <Route path="reviews" element={<AdminReviewsPage />} />
          <Route path="leads" element={<AdminLeadsPage />} />

        </Route>
      </Routes>
      <Footer />
    </>
  );
}
